class Status{
    unauthorized(response){
        if(response == 401){
            localStorage.clear()
            location.reload()
        }
    }
}

export default new Status();